import React, { Component } from "react";
import bgImage from "./img/kiwi_sweta-verma-tikwxTAyI4E-unsplash_2.jpg";
import Link from "../../../../lib/components/Link/Link";

class LandingPage extends Component {

  render() {
    return <div className='bg-black flex items-center justify-center min-h-screen'>
      <Link to='/demolink'>
        <img src={bgImage} alt="bgImage" className="mx-auto"/>
      </Link>
    </div>
  }
}

export default LandingPage;
